export default "__VITE_ASSET__f85e6d94__"